"use strict";

/**
 * Type-safe language configuration for i18n
 * This is the single source of truth for supported languages across all MFEs
 */

/**
 * All available languages in the system
 * This is the complete list that can be enabled
 * Ordered alphabetically by native name
 */
export const ALL_LANGUAGES = [{
  value: 'de',
  label: 'German',
  flag: '🇩🇪',
  nativeName: 'Deutsch',
  nativeCode: 'DE',
  direction: 'ltr'
}, {
  value: 'en',
  label: 'English',
  flag: '🇬🇧',
  nativeName: 'English',
  nativeCode: 'EN',
  direction: 'ltr'
}, {
  value: 'es',
  label: 'Spanish',
  flag: '🇪🇸',
  nativeName: 'Español',
  nativeCode: 'ES',
  direction: 'ltr'
}, {
  value: 'fr',
  label: 'French',
  flag: '🇫🇷',
  nativeName: 'Français',
  nativeCode: 'FR',
  direction: 'ltr'
}, {
  value: 'it',
  label: 'Italian',
  flag: '🇮🇹',
  nativeName: 'Italiano',
  nativeCode: 'IT',
  direction: 'ltr'
}, {
  value: 'nl',
  label: 'Dutch',
  flag: '🇳🇱',
  nativeName: 'Nederlands',
  nativeCode: 'NL',
  direction: 'ltr'
}, {
  value: 'pl',
  label: 'Polish',
  flag: '🇵🇱',
  nativeName: 'Polski',
  nativeCode: 'PL',
  direction: 'ltr'
}, {
  value: 'sv',
  label: 'Swedish',
  flag: '🇸🇪',
  nativeName: 'Svenska',
  nativeCode: 'SV',
  direction: 'ltr'
}, {
  value: 'ja',
  label: 'Japanese',
  flag: '🇯🇵',
  nativeName: '日本語',
  nativeCode: '日本',
  direction: 'ltr'
}];
export const DEFAULT_LANGUAGE = 'en';
export const LANGUAGE_STORAGE_KEY = 'i18nextLng';
export const LANGUAGE_COOKIE_NAME = 'i18next';

/**
 * Get language configuration by code
 */
export function getLanguageByCode(code) {
  return ALL_LANGUAGES.find(lang => lang.value === code);
}

/**
 * Get native code for a language
 */
export function getNativeCode(code) {
  const language = getLanguageByCode(code);
  return (language === null || language === void 0 ? void 0 : language.nativeCode) || code.toUpperCase();
}

/**
 * Get all language codes
 */
export function getAllLanguageCodes() {
  return ALL_LANGUAGES.map(lang => lang.value);
}

/**
 * Check if a language code is valid
 */
export function isValidLanguageCode(code) {
  return ALL_LANGUAGES.some(lang => lang.value === code);
}

/**
 * Mapping of language codes to their corresponding feature flag names.
 * Used to determine which languages should be available based on enabled feature flags.
 */
export const LANGUAGE_FEATURE_FLAG_MAP = {
  en: 'language-english',
  de: 'language-german',
  fr: 'language-french',
  es: 'language-spanish',
  it: 'language-italian',
  nl: 'language-dutch',
  pl: 'language-polish',
  sv: 'language-swedish',
  ja: 'language-japanese'
};

/**
 * All language feature flag names.
 * Apps should include these in their FeatureFlagsProvider to enable language selection.
 */
export const LANGUAGE_FEATURE_FLAGS = Object.values(LANGUAGE_FEATURE_FLAG_MAP);